import { TMenuCategories } from 'src/types/MenuItems/menuItem.model';
import { useQuery } from 'react-query';
import { getMenuCategories } from 'src/apis/Commons/commons';

function useMenuItem() {
  const { data } = useQuery<TMenuCategories[]>(['getMenuCategories'], async () => getMenuCategories(), {
    cacheTime: 0
  });

  return { data };
}

export default useMenuItem;
